import { motion } from "framer-motion";

export default function PageLoader() {
  return (
    <div
      data-testid="page-preloader"
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#FAF6F0] text-[#3B2818] select-none"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="flex flex-col items-center text-center px-4"
      >
        {/* Animated Brand Logo Accent */}
        <div className="relative flex items-center justify-center mb-6">
          <div className="h-16 w-16 rounded-full border-2 border-[#C06A22]/20 border-t-[#C06A22] animate-spin" />
          <span className="absolute font-script text-2xl text-[#C06A22]">S</span>
        </div>

        {/* Brand Name */}
        <div className="flex items-baseline gap-2 mb-2">
          <span className="font-serif text-3xl md:text-4xl text-[#3B2818] leading-none">
            Signature
          </span>
          <span className="font-script text-3xl md:text-4xl text-[#C06A22] leading-none">
            Spoon
          </span>
        </div>

        <p className="text-[11px] uppercase tracking-[0.24em] text-[#6B5343] font-medium">
          Fresh Bakes • Pune & Karad
        </p>

        {/* Skeleton Shimmer Progress Bar */}
        <div className="w-48 h-1 bg-[#3B2818]/10 rounded-full mt-6 overflow-hidden relative">
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: "100%" }}
            transition={{
              repeat: Infinity,
              duration: 1.2,
              ease: "easeInOut",
            }}
            className="w-full h-full bg-[#C06A22] rounded-full"
          />
        </div>
      </motion.div>
    </div>
  );
}
